import React from "react";
import { Row, Col, Card } from "antd";

import { MdDelete, MdModeEditOutline, MdEmail } from "react-icons/md";
import { BiMobile } from "react-icons/bi";
import { SiHomeassistantcommunitystore } from "react-icons/si";
import "./index.css";

export default function PlantInfoCard({
  inputText,
  cardIcon,
  data,
  deleteHandler,
  onHandleUpdate,
  ...props
}) {
  return (
    <Row justify="center">
      <Col xs={24} sm={24} md={24} lg={24} xl={24} className="custom">
        <Card style={{ height: "258px" }} className="ant-card-body ">
          <Row justify="space-between" style={{ marginBottom: "20px" }}>
            <Col span={18}>
              <h4 className="text-left">{data?.name}</h4>
            </Col>
            <Col span={6}>
              <MdDelete
                size="20"
                className="pointer-cursor"
                onClick={() => deleteHandler({ id: data.id })}
              />
              <MdModeEditOutline
                size="20"
                className="pointer-cursor"
                onClick={() => onHandleUpdate(data)}
              />
            </Col>
          </Row>
          <Row gutter={[0, 2]} justify="space-between">
            <Col span={4} className="text-right ">
              <BiMobile size="25" />
            </Col>
            <Col span={19}>
              <p className="st-primary text-left m-zero">Phone</p>
              <p className=" text-left three-dot">{data?.phone}</p>
            </Col>
          </Row>
          <Row gutter={[0, 2]} justify="space-between">
            <Col span={4} className="text-right ">
              <MdEmail size="25" />
            </Col>
            <Col span={19}>
              <p className="st-primary text-left m-zero">Email</p>
              <p className=" text-left three-dot">{data?.email}</p>
            </Col>
          </Row>
          <Row gutter={[0, 2]} justify="space-between">
            <Col span={4} className="text-right ">
              <SiHomeassistantcommunitystore size="25" />
            </Col>
            <Col span={19}>
              <p className="st-primary text-left m-zero ">Address</p>
              <p className=" text-left three-dot" title={data?.address}>
                {data?.address}
              </p>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );
}
